import React from 'react';

function AboutIllustration() {
  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <img
        src="/images/Stupa-primarylogo.png"
        alt="STUPA Developmental Foundation"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          padding: '2rem',
        }}
      />
    </div>
  );
}

export default AboutIllustration;
